import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import SelectAcerBrag from '../../components/SelectAcerBrag';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import userAPI from '../../services/UserApi';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import { AppContext } from '../../contexts/AppContext';
import { isValidEmail } from '../../utils/MiscellaneousUtils';
import { separations } from '../../constants/StyleConstants';
import { Fragment } from 'react';

import EmailNotificationAPI from '../../services/EmailNotificationsApi';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';


const useStyles = makeStyles(theme => ({
  ...separations,
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '22em',
  },
  contiguous: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '1em',
  },
}));

const CreateEmailNotificationDialog = ({ open, setOpen, readOnly, reloadGrid }) => {
  const classes = useStyles();
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [openBackDrop, setOpenBackDrop] = useState(false);

  const [email, setEmail] = useState('');
  const [selectedSupplier, setSelectedSupplier] = useState(null)
  const [readOnlyEmail, setReadOnlyEmail] = useState(false)

  useEffect(() => {
    if(!open){
      resetFields();
    } 
  },[open])
  

  const resetFields = () => {
    setSelectedSupplier(null);
    setEmail('');
    setReadOnlyEmail(false)
  };


  const finish = () => {
    setOpen(false);
    setTimeout(() => {
      resetFields();
      setOpenBackDrop(false);
    }, 500);


  };

  useEffect(() => {
    
    if(selectedSupplier){
      verifyEmail();
    } else {
      setEmail('');
      setReadOnlyEmail(false);
    }
  }, [selectedSupplier])

  const newEmailNotification = async () => {

    const request = {
      SupplierId: selectedSupplier.id,
      Email: email
    };

    EmailNotificationAPI
      .newEmailNotification(request)
      .then(result => {
        reloadGrid();
        finish();
        showSuccess('Email agregado con éxito');
      })
      .catch(error => {
        finish();

        if(error.response){
          showWarning(error.response.data);
        } else {
          
          showError('No se pudo agregar el nuevo Email');
        }

      });
  };


  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !selectedSupplier)) {
      errorMessages.push('Debe seleccionar un proveedor');
    }

    if ((errors[i++] = email.isBlank())) {
      errorMessages.push('Debe completar el email');
    } else if ((errors[i++] = !isValidEmail(email))) {
      errorMessages.push('El email ingresado no es válido');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSave = () => validate() && newEmailNotification();//handleSave();

  const verifyEmail = () => {


    const request = {
      SupplierId: selectedSupplier.id
    }

    EmailNotificationAPI.getEmail(request)
    .then(res => {
      
      if(res){
        console.log("res: ", res)
        if(!res.isBlank()){
          setEmail(res);
          setReadOnlyEmail(true);
          showWarning('El proveedor ya posee un email de notificación');
        }

      } else {
        setEmail('');
       
      }
    })
    .catch(error => showError("Error al verificar la existencia del email"))
  }


  return (
    <Fragment>

      <DialogAcerBrag
        open={open}
        setOpen={setOpen}
      
        title={'Agregar email de notificación'}
        action={!readOnlyEmail ? validateAndSave : undefined}>
        <LimitedBackdrop open={openBackDrop}>
          <CircularProgress color="primary" />
        </LimitedBackdrop>
        <div className={classes.dialogContainer}>

          <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier}/>
          <TextField
            margin="dense"
            id="email"
            label="Email"
            onChange={e => setEmail(e.target.value)}
            inputProps={{readOnly: readOnlyEmail}}
            value={email}
            
          />

        </div>
      </DialogAcerBrag>
    </Fragment>
  );
};
export default CreateEmailNotificationDialog;